import {Recipe, RecipeComponent} from '@domain/materials'
import {RecipeComponentType} from '@domain/shared'

export const getRecipeComponentsWithMaterial = (
  materialId: number,
  recipe: Recipe,
  componentTypes: RecipeComponentType[]
): RecipeComponent[] => {
  return recipe.components
    .filter((component) => componentTypes.includes(component.type))
    .filter((component) => component.material.id === materialId)
}
